module.exports = __webpack_public_path__ + "media/images/shared/side_menus/icons/signin-0df0c395d14a4bc74f79ce4a273ef50e.png";